import styled from 'styled-components';
import currencyFormatter from '~/libs/currency-formatter.js';

const StyledStakesPillContainer = styled.div`
	position: absolute;
	z-index: 1;
	bottom: 6px;
	width: 100%;
	display: flex;
	align-content: center;
	justify-content: center;
`;

const StyledStakesPill = styled.div`
	border-radius: 28px;
	padding: 0px 6px;
	background-color: var(--lc-live-casino-card-bg);
	span {
		display: inline-block;
		width: 100%;
		font: var(--label-regular);
		text-align: center;
		line-height: var(--stakes-pill-line-height);
		font-size: var(--lc-card-font-size);
		color: rgba(var(--active-players-color), 1);
	}
`;

const StakesPill = ({ min, max, currency }) => {
	if (!(min && max)) {
		return null;
	}

	const minFormatted = currencyFormatter.format(min, currency, undefined, true);

	const maxFormatted = currencyFormatter.format(max, currency, undefined, true);

	const formattedStakesText = `${minFormatted} - ${maxFormatted}`;

	return (
		<StyledStakesPillContainer data-testid="stakes-pill">
			<StyledStakesPill>
				<span>{formattedStakesText}</span>
			</StyledStakesPill>
		</StyledStakesPillContainer>
	);
};

export default StakesPill;
